"use strict";

const config = require('../../../../../config/locales_json/packs/private/admin/clients.json');
const language = $('body').data("language");

var RecruiterDocumentsDatatable = function () {
  // Define shared variables
  var table = document.getElementById('kt_recruiter_documents_datatable');
  var datatable;

  // Private functions
  var initRecruiterDocumentsTable = function () {
      // Init datatable --- more info on datatables: https://datatables.net/manual/
      datatable = $(table).DataTable({
        info: false,
        paging: false, // Desactiva el paginador 
        order: [[0,'desc']],
        pageLength: 20,
        lengthChange: false,
        searching: true,
        autoWidth: false, // Desactiva el ajuste automático de ancho
        responsive: true, // Opcional: hace que la tabla sea responsive
        columns: [
          { width: '10%' },
          { width: '10%' },
          { width: '60%' },
          { width: '20%' },
        ]
      });
  }

  // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
  var handleSearchDatatable = () => {
      const filterSearch = document.querySelector('[data-kt-recruiter-documents-table-filter="search"]');
      filterSearch.addEventListener('keyup', function (e) {
        datatable.search(e.target.value).draw();
      });
  }

  return {
      // Public functions  
      init: function () {
          if (!table) {
              return;
          }

          initRecruiterDocumentsTable();
          handleSearchDatatable();
          // Remueve el input de busqueda por defecto
          $(".dt-search").remove();
      }
  }
}();


jQuery(document).ready(function() {
    if($("#kt_recruiter_documents_datatable").length > 0){
        RecruiterDocumentsDatatable.init();
    }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
